import { render, staticRenderFns } from "./tablePagination.vue?vue&type=template&id=1b9fd729"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports